import { Login } from '@/views/login';

export default Login;
